import { Service } from "../src/store/service";
const Api = new Service();

export async function fetchSuperkisParentsKids() {
  try {
    const res = await Api.getRequest(`fetch-parent-kids`);
    // console.log("response kidsss", res.data.data);
    if (res.data.success) {
      if ((!localStorage.getItem('kidDetails')) && (res.data.data.length > 0) || (localStorage.getItem('kidDetails') == undefined)) {
        localStorage.setItem("kidDetails", JSON.stringify(res.data.data[0]));
        window.dispatchEvent(new Event('storage-update'));
      }
      return res; 
    }
  } catch (error) {
    console.log("err:", error);
    throw error; // Re-throw so the component knows there was an error
  }
}

// export async function fetchSuperkisParentsKids() {
//     try {
//       await Api.getRequest(`fetch-parent-kids`).then((res: any) => {
//         console.log("response kidsss", res);
//         return res; 
//       }).catch ((error: any) => {
//         console.log("err:", error);
//       });
//     } finally {
//       // console.log("closed");
//     }
// }